import { render, staticRenderFns } from "./DowntimeCategoryWizard.vue?vue&type=template&id=4b9bf7ec&scoped=true"
import script from "./DowntimeCategoryWizard.vue?vue&type=script&lang=js"
export * from "./DowntimeCategoryWizard.vue?vue&type=script&lang=js"
import style0 from "./DowntimeCategoryWizard.vue?vue&type=style&index=0&id=4b9bf7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bf7ec",
  null
  
)

export default component.exports